import { useDashboardStore } from '../stores/dashboardStore'
import { useDebouncedValue } from './useDebouncedValue'

/**
 * Filterargumentene som både `dashboard_table_orders` og
 * `dashboard_table_orders_totals` tar.
 *
 * Én kilde, to kallere — samme grunn som at de to RPC-ene deler
 * WHERE-bygger i migrasjon 171: skulle listene drive fra hverandre, ville
 * totalene beskrive en annen mengde enn den operatøren ser på skjermen.
 * Objektet brukes også direkte som query key, så nøkkelen kan ikke gå ut
 * av takt med argumentene den beskriver.
 */
export function useDashboardFilterArgs(orgId: string | undefined) {
  const statusFilter = useDashboardStore((s) => s.statusFilter)
  const employeeFilter = useDashboardStore((s) => s.employeeFilter)
  const templateFilter = useDashboardStore((s) => s.templateFilter)

  // Datofiltre og tallintervaller — ingen debounce, brukeren velger og bekrefter
  const orderDateFrom = useDashboardStore((s) => s.orderDateFrom)
  const orderDateTo = useDashboardStore((s) => s.orderDateTo)
  const deliveryDateFrom = useDashboardStore((s) => s.deliveryDateFrom)
  const deliveryDateTo = useDashboardStore((s) => s.deliveryDateTo)
  const orderIdFrom = useDashboardStore((s) => s.orderIdFrom)
  const orderIdTo = useDashboardStore((s) => s.orderIdTo)

  // Tekstfiltre og globalt søk — debounced 300 ms
  const customerNameFilter = useDebouncedValue(useDashboardStore((s) => s.customerNameFilter))
  const referenceFilter = useDebouncedValue(useDashboardStore((s) => s.referenceFilter))
  const yourRefFilter = useDebouncedValue(useDashboardStore((s) => s.yourRefFilter))
  const infoFilter = useDebouncedValue(useDashboardStore((s) => s.infoFilter))
  const phoneFilter = useDebouncedValue(useDashboardStore((s) => s.phoneFilter))
  const emailFilter = useDebouncedValue(useDashboardStore((s) => s.emailFilter))
  const customerIdFilter = useDebouncedValue(useDashboardStore((s) => s.customerIdFilter))
  const deliveryNameFilter = useDebouncedValue(useDashboardStore((s) => s.deliveryNameFilter))
  const searchQuery = useDebouncedValue(useDashboardStore((s) => s.searchQuery))

  return {
    p_org_id: orgId!,
    p_status_filter: statusFilter.length > 0 ? statusFilter : undefined,
    p_employee_filter: employeeFilter.length > 0 ? employeeFilter : undefined,
    p_template_filter: templateFilter.length > 0 ? templateFilter : undefined,
    p_order_date_from: orderDateFrom || undefined,
    p_order_date_to: orderDateTo || undefined,
    p_delivery_date_from: deliveryDateFrom || undefined,
    p_delivery_date_to: deliveryDateTo || undefined,
    p_customer_name_filter: customerNameFilter || undefined,
    p_reference_filter: referenceFilter || undefined,
    p_your_ref_filter: yourRefFilter || undefined,
    p_info_filter: infoFilter || undefined,
    p_phone_filter: phoneFilter || undefined,
    p_email_filter: emailFilter || undefined,
    p_customer_id_filter: customerIdFilter || undefined,
    p_search_query: searchQuery || undefined,
    p_order_id_from: orderIdFrom ?? undefined,
    p_order_id_to: orderIdTo ?? undefined,
    p_delivery_name_filter: deliveryNameFilter || undefined,
  }
}
